import React from "react";
import H2 from "@/atoms/text/H2";
import Para from "@/atoms/text/Para";
import CardWithImg from "@/components/molecules/CardWithImg";

export default function BlogArticles({
  title,
  content,
  linkText,
  href,
  cardData,
}) {
  return (
    <section className="bc-blue-light pv-15-d pv-8">
      <div className="container">
        <H2
          className={`ta-center bold ${content ? "mb-5" : "mb-10-d mb-7"}`}
          dangerouslySetInnerHTML={{ __html: title }}
        ></H2>
        {content && (
          <Para
            desktopSize="lg"
            mobileSize="lg"
            color="black"
            dangerouslySetInnerHTML={{ __html: content }}
            className="mb-8-d mb-7 ta-center"
          />
        )}
        <ul className="fx--stretch-d fx-v fx--c-m fx--sb fx--cv">
          {cardData.map((card, idx) => (
            <li
              key={idx}
              className={`${
                idx === cardData.length - 1 ? "" : "mb-7 mb-reset-d"
              }`}
            >
              <CardWithImg
                isBlog
                content={card.description}
                image={card.image}
                label={card.label}
                href={card.href}
                readTime={card.readTime}
              />
            </li>
          ))}
        </ul>
        {href && (
          <div className="ta-center mt-8">
            <a href={href} className="btn btn--link btn--link-lg">
              {linkText}
            </a>
          </div>
        )}
      </div>
    </section>
  );
}
